import { Company } from '@backend/domain'
import { CompanyResponse } from '../types'

export class CompanyMapper {
	static entityToResponse(company: Company): CompanyResponse {
		return {
			id: company.id,
			name: company.name,
			email: company.email,
			emailVerified: company.emailVerified,
		}
	}
}
